import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Form, Select, Spin, Button, Modal, Image } from 'antd';
import './productPricing.less';

import ProductPricingTable from './productPricingTable';
import {
  companyIndustryType,
  dateFormat,
  GujaratCo,
  stateID,
  SupplierModuleTypeEnum,
  UserTypeDict,
} from '../../../../utils/settings';
import {
  GetAllCityOfState,
  GetAllStates,
  GetDealerCompaniesBaseProductPrice,
  GetDealerCompaniesNow,
  GetProductPrices,
  getSkuDetails,
  GetSubProducts,
} from '../../../auth/action/util_actions';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { getCompanySuppliersAction } from '../../../../v2/BCMOrder/Action';
import { getpricingGeographyAction } from '../../../../v2/Onboarding/auth/action';
import { toast } from 'react-toastify';

const ProductPricing = () => {
  const { state } = useLocation();
  const [companies, setCompanies] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [company, setCompany] = useState(null);
  const [subProduct, setSubProduct] = useState(null);
  const [industryType, setIndustryType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [stateArr, setStateArr] = useState([]);
  const [distArr, setDistArr] = useState([]);
  const [pricingGeographyList, setPricingGeographyList] = useState([]);
  const [districtId, setDistrictId] = useState(null);
  const [currentStateId, setCurrentStateId] = useState(null);
  const [manufacturerPricingGeographyId, setManufacturerPricingGeographyId] =
    useState(null);

  const [form] = Form.useForm();

  const [lastUpdatedDate, setLastUpdatedDate] = useState(null);

  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    productPrices();
  }, [company, subProduct, manufacturerPricingGeographyId]);

  useEffect(() => {
    getCompanies();
  }, []);

  const productPrices = async () => {
    setLoader(true);
    let obj = {};

    obj = {
      sub_product: subProduct,
      cement_co_id: company,
      district_id: districtId,
      manufacturer_pricing_geography_id: manufacturerPricingGeographyId,
    };

    let { error, data, message } = await GetProductPrices(obj);
    setLoader(false);

    if (!error) {
      setProducts(data.map((item) => item));
    }
  };
  const getCompanies = async () => {
    const { data, error } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.pricing_enabled,
    );

    if (!error) {
      const temp = data
        .map((item) => {
          return item.suppliers_list;
        })
        .flat()
        .filter((item) => item?.price_visibility);
      setCompanies(temp);

      if (state?.isFromDashboard) {
        setIndustryType(state?.item?.industry_type);
        setCompany(state?.item?.company_id);
        SubProductsfunction(state?.item?.company_id);
      } else {
        setIndustryType(temp[0]?.industry_type);
        setCompany(temp[0]?.id);
        SubProductsfunction(temp[0]?.id);
      }
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const findIndustryTypeByCompanyId = (companyId) => {
    const company = companies.find((company) => company.id === companyId);
    setIndustryType(company.industry_type);
  };

  const SubProductsfunction = async (id) => {
    const { data, message, error } = await GetSubProducts(id);

    if (!error) {
      if (data.length > 0) {
        setSubProduct(data[0].sub_product);
        setSubProducts(
          data.map((prod) => {
            return {
              name: prod.sub_product,
              id: prod.sub_product,
            };
          }),
        );
      }
    }
  };
  const getBasePrice = async (companyID) => {
    const { error, data } = await GetDealerCompaniesBaseProductPrice(
      Number(companyID),
    );

    if (!error) {
      setLastUpdatedDate(moment(data[0]?.last_updated).format(dateFormat));
    }
  };

  const GetAllStatesEffect = async () => {
    let { error, data } = await GetAllStates();
    if (!error && data) {
      setStateArr(data);
    }
  };

  useEffect(() => {
    GetAllStatesEffect();
  }, []);

  const GetAllCityOfStateEffect = async () => {
    if (currentStateId >= 0) {
      let { error, data } = await GetAllCityOfState(currentStateId);
      if (!error && data) {
        setDistArr(data);
      }
    }
  };

  useEffect(() => {
    if (company) getBasePrice(company);
  }, [company]);

  useEffect(() => {
    GetAllCityOfStateEffect();
  }, [currentStateId]);
  const getGeographyPricing = async (district_id, manufacturer_id) => {
    console.log('district_id', district_id);
    console.log('manufacturer_id', manufacturer_id);
    const params = new URLSearchParams();
    params.append('district_id', district_id);
    params.append('manufacturer_id', manufacturer_id);

    const { data, error, message } = await getpricingGeographyAction(params);

    if (!error) {
      setPricingGeographyList(
        data.map((vv) => ({
          label: vv.pricing_geography_name,
          value: vv.pricing_geography_id,
        })),
      );
    } else return toast.error(message);
  };
  useEffect(() => {
    if (districtId && company) getGeographyPricing(districtId, company);
  }, [districtId, company]);

  const stateOptions =
    stateArr.length > 0
      ? stateArr.map((state) => ({ label: state.state_name, value: state.id }))
      : [];

  const districtOptions =
    distArr.length > 0
      ? distArr.map((district) => ({
          label: district.district_name,
          value: district.id,
        }))
      : [];
  const pricingGeographyOption =
    pricingGeographyList.length > 0
      ? pricingGeographyList.map((item) => ({
          label: item.label,
          value: item.value,
        }))
      : [];

  const companyOptions =
    companies &&
    companies.map((item) => {
      return { label: item.name, value: item.id };
    });

  const companyProductOptions =
    subProducts &&
    subProducts.map((item) => {
      return { label: item.name, value: item.id };
    });

  return (
      <div
        className='inventory-view'
        style={{ width: '100%' }}
      >
        <div className='inventory-view-content inventory-view-content-mobile'>
          <div className='title'>
            <h2 className='text'>Product Pricing</h2>
          </div>

          <div className='filterContainer'>
            {/* Company Selection */}
            <div style={{ margin: '0 10px 10px 0' }}>
              <h5>Select Company</h5>
              <Select
                showSearch
                style={{
                  width: '190px',
                }}
                disabled={state?.isFromDashboard}
                value={company}
                optionFilterProp='children'
                placeholder={'Companies'}
                onChange={(e) => {
                  findIndustryTypeByCompanyId(e);
                  setCompany(e);
                  SubProductsfunction(e);
                }}
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={companyOptions}
              />

              {/* Sub Product Selection */}

              <>
                <h5 style={{ marginTop: '10px' }}>Select Sub Product</h5>
                <Select
                  showSearch
                  style={{
                    width: '190px',
                  }}
                  value={subProduct}
                  optionFilterProp='children'
                  placeholder={'Companies'}
                  onChange={(e) => {
                    setSubProduct(e);
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={companyProductOptions}
                />
                <h4 style={{ marginTop: '10px' }}>
                  Last Updated: {lastUpdatedDate}
                </h4>
                {(industryType === companyIndustryType['ERW'] ||
                  industryType === companyIndustryType['ANGLE']) && (
                  <>
                    <h4 style={{ marginTop: '10px' }}>
                      All Prices are EX and Inclusive of GST
                    </h4>
                    <Button
                      className={'saleAggRow__subtitle'}
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                      style={{
                        fontWeight: 'bold',
                        fontSize: '14px',
                        color: 'white',
                      }}
                      type={'primary'}
                    >
                      Dia Difference
                    </Button>
                  </>
                )}
                <Modal
                  open={isModalOpen}
                  onOk={handleOk}
                  onCancel={handleCancel}
                >
                  <Image
                    src={
                      industryType === companyIndustryType['ERW']
                        ? require('./Gravity_ERW_prices.png')
                        : require('./Bhavani_Angle_prices.png')
                    }
                  />
                </Modal>
              </>
            </div>
            {/* State */}
            <div>
              <h5>Select State</h5>
              <Select
                style={{
                  width: '190px',
                }}
                showSearch
                value={currentStateId}
                allowClear
                placeholder={t('onboarding.state')}
                onChange={(e) => {
                  setCurrentStateId(e);
                  setDistrictId(null);
                  setManufacturerPricingGeographyId(null);
                  setPricingGeographyList([]);
                }}
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={stateOptions}
              />
              <h5 style={{ marginTop: '10px' }}>Select District</h5>
              <Select
                style={{
                  width: '190px',
                }}
                allowClear
                value={districtId}
                showSearch
                placeholder={t('onboarding.city')}
                onChange={(e) => {
                  setDistrictId(e);
                  setManufacturerPricingGeographyId(null);
                  setPricingGeographyList([]);
                }}
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={districtOptions}
              />
            </div>
            <div style={{ margin: '0px 10px' }}>
              <h5>Select Pricing Geography</h5>
              <Select
                style={{
                  width: '190px',
                }}
                showSearch
                value={manufacturerPricingGeographyId}
                allowClear
                placeholder={'Pricing Geography'}
                onChange={(e) => setManufacturerPricingGeographyId(e)}
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={pricingGeographyOption}
              />
            </div>
          </div>

          <Spin spinning={loader}>
            <div className='inventory-data'>
              {products.length > 0 && products ? (
                <div>
                  <div className='inventory-table inventory-table__heading'>
                    <div className='properties'>
                      <div className='brand-details'>{`Product (UOM-${products[0]?.uom})`}</div>
                    </div>
                    <div className='qty'>Price</div>
                  </div>
                  {products &&
                    products.map((product) => (
                      <ProductPricingTable
                        name={product.name}
                        price={product.current_price_per_unit}
                      />
                    ))}
                </div>
              ) : (
                <div
                  className='inventory-table'
                  style={{ width: '100%' }}
                >
                  <p
                    style={{
                      textAlign: 'center',
                      width: '100%',
                      fontSize: '20px',
                      color: '#f49d3f',
                      fontWeight: 'bold',
                    }}
                  >
                    No Data Found
                  </p>
                </div>
              )}
            </div>
          </Spin>
        </div>
        <div id='bottom-padding'></div>
      </div>
  );
};

export default ProductPricing;
